import { Controller } from "@hotwired/stimulus"

const COOKIE_MAX_AGE = 60 * 60 * 24 * 365

export default class extends Controller {
  static targets = ["summary", "settings", "category"]
  static values = {
    categories: Array,
    cookieName: String,
  }

  connect() {
    this.element.hidden = false
    this.showSummary()
  }

  acceptAll() {
    this.saveConsent(this.buildConsent(true))
  }

  acceptNecessary() {
    this.saveConsent(this.buildConsent(false))
  }

  openSettings() {
    this.summaryTarget.hidden = true
    this.settingsTarget.hidden = false
  }

  closeSettings() {
    this.showSummary()
  }

  saveSettings() {
    const categories = {}

    for (const key of this.categoriesValue) {
      const input = this.categoryTargets.find((categoryInput) => {
        return categoryInput.dataset.ccBannerCategory === key
      })

      categories[key] = input ? input.checked : key === "necessary"
    }

    this.saveConsent(categories)
  }

  buildConsent(optionalAccepted) {
    const categories = {}

    for (const key of this.categoriesValue) {
      categories[key] = key === "necessary" || optionalAccepted
    }

    return categories
  }

  showSummary() {
    this.summaryTarget.hidden = false
    this.settingsTarget.hidden = true
  }

  saveConsent(categories) {
    const payload = {
      decidedAt: new Date().toISOString(),
      categories,
    }
    const cookieValue = encodeURIComponent(JSON.stringify(payload))
    const cookieOptions = [
      "path=/",
      `max-age=${COOKIE_MAX_AGE}`,
      "SameSite=Lax",
    ].join("; ")

    document.cookie = `${this.cookieNameValue}=${cookieValue}; ${cookieOptions}`
    window.location.reload()
  }
}
